const policiesQuotes = {
  POLICIES_QUOTES_FILTER_CHANGE_SUCCESS:
    'POLICIES_QUOTES_FILTER_CHANGE_SUCCESS',
  POLICIES_QUOTES_VIEW_DETAILS_REQUEST: 'POLICIES_QUOTES_VIEW_DETAILS_REQUEST',
  POLICIES_QUOTES_BIND_REQUEST_SENT: 'POLICIES_QUOTES_BIND_REQUEST_SENT',
};

export default policiesQuotes;
